import {
    React, ui
} from "aaa";

export const RequiredFields = () => {
    return (
        <div style={{ color: "silver", fontSize: 14 }}><br /><br />
            {ui.__("requiredFields")}
        </div>
    );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Common.tsx